import { Component, Input, inject } from '@angular/core';
import { WINDOW } from '@shared/dom';

@Component({
  selector: 'app-media-error',
  templateUrl: './media-error.component.html',
  styleUrls: ['./media-error.component.scss'],
  standalone: false,
})
export class MediaErrorComponent {
  private readonly window = inject<Window>(WINDOW);

  @Input() showBrowserProblemLink: boolean = false;

  public refresh(): void {
    this.window.location.reload();
  }
}
